import React, { useMemo } from 'react'
import { Box, Typography, Stack, Link } from '@mui/material'
import { CommonButton, CommonDialog } from '@/components/common'
import { AccountIcon, PhoneIcon, LaptopIcon } from '@/icons'

export const DescriptionDialog = ({ open, onClose, item }) => {
  const { title, description, phone, website, iconUrl } = item

  const paragraphs = useMemo(() => {
    if (!description) return []
    return Array.isArray(description) ? description : [description]
  }, [description])

  return (
    <CommonDialog
      open={!!open}
      onClose={onClose}
      title={null}
      maxWidth='md'
      fullWidth
    >
      <Stack
        pt={2}
        pb={3}
        spacing={2}
        alignItems='center'
        sx={{ textAlign: 'center' }}
      >
        {iconUrl ? (
          <img
            src={iconUrl}
            alt='profile'
            style={{ width: 64, height: 64, borderRadius: '50%' }}
          />
        ) : (
          <AccountIcon color='primary' sx={{ fontSize: 64 }} />
        )}
        <Typography variant='h6' color='primary'>
          {title}
        </Typography>

        <Box sx={{ maxWidth: 800, textAlign: 'left' }}>
          {paragraphs.map((p, idx) => (
            <Typography key={idx} variant='body1' sx={{ mb: 2 }}>
              {p}
            </Typography>
          ))}
        </Box>

        <Stack direction='row' spacing={3} sx={{ mt: 2 }} alignItems='center'>
          <CommonButton variant='primary' onClick={onClose}>
            Go Back
          </CommonButton>
          {phone && (
            <Stack direction='row' spacing={1} alignItems='center'>
              <CommonButton variant='secondary' iconOnly={<PhoneIcon />} />
              <Typography variant='body1'>{phone}</Typography>
            </Stack>
          )}
          {website && (
            <Stack direction='row' spacing={1} alignItems='center'>
              <CommonButton variant='secondary' iconOnly={<LaptopIcon />} />
              <Link href={website} target='_blank' rel='noopener'>
                {website}
              </Link>
            </Stack>
          )}
        </Stack>
      </Stack>
    </CommonDialog>
  )
}
